<div class="media-progress">
    <div class="media-progress__content">
        <kz-percentage
            [pourcent]="mediaService.progress | async"
            [strokeWidth]="5"
            [radius]="50"
            [animateAtFirst]="false"
            displayLabel="true"
            [percentageContext]="designPro ? 'decorator' : 'defaut'"
        ></kz-percentage>
    </div>
    <div *ngIf="showLabel && !isVideo" class="media-progress__label" i18n="@@upload.progress.message.picture">Please wait for your images to load.</div>
    <div *ngIf="showLabel && isVideo" class="media-progress__label" i18n="@@upload.progress.message.video">Please wait for your video to load.</div>
</div>
